import * as actions from './actions';
import * as profileActions from '../UserProfile/actions';

import { ActionType, getType } from 'typesafe-actions';
import { PagesMap } from '../../Models';
import * as moment from 'moment';

export interface PagesHistoryState {
  readonly items: PagesMap;
  readonly lastSyncDate?: Date;
}

export const initialState: PagesHistoryState = {
  items: {},
};

type HistoryAction = ActionType<typeof actions> | ActionType<typeof profileActions>;

const common = (state: Mutable<PagesHistoryState> = initialState, action: HistoryAction): PagesHistoryState => {
  switch (action.type) {
    case getType(actions.createPage): {
      const { dateId } = action.payload;

      const existingPage = state.items[dateId];
      const newPage = action.payload;

      if (existingPage && existingPage.text !== newPage.text && !existingPage.isDeleted) {
        existingPage.text = existingPage.text + `\n` + newPage.text;
        state.items[dateId] = existingPage;
      } else {
        state.items[dateId] = newPage;
      }
      break;
    }
    case getType(actions.setPagesHistoryFromExternalSource): {
      state.items = action.payload;
      break;
    }
    case getType(actions.updatePage): {
      const { dateId } = action.payload;
      state.items[dateId] = action.payload;
      break;
    }
    case getType(actions.deletePage): {
      const { dateId } = action.payload;
      state.items[dateId].isDeleted = true;
      state.items[dateId].updatedAt = moment().toISOString();
      break;
    }
    case getType(actions.updatePagesHistoryLastSyncDate): {
      state.lastSyncDate = action.payload;
      break;
    }
    case getType(actions.deleteAllPages): {
      state.items = {};
      break;
    }
    case getType(profileActions.clickUserProfileLogout): {
      state.items = {};
      break;
    }
  }

  return state;
};

export default common;



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/reducer.ts